<template>
  <div class="listmain ">
      <h1 class="firTitle">信息流</h1>
      <span>

 <h3 class="sedTitle">信息流 API 的使用</h3>

<p class="ql-long-7802039">
	<span class="ql-author-7802039 ql-size-9">头文件 OrionSDK+OVSChatAPI.h</span>
</p>

<p class="ql-long-7802039">
	<strong class="ql-author-7802039 ql-size-9">单独使用信息流API，不需要再调用信息流UI。获取到信息流后，可根据相关信息流ID，对识别不准确的信息调用反馈接口</strong>
</p>

</span>
          <highlight-code lang="javascript">
            <span>
                /**
 * @brief 信息流API 使用
 */
- (void)chatAPIUsage {
    // 用户需要传入当前设备，获取当前设备的信息流，demo 中只是取的设备列表中最后一个。
    if ([OVSUserModel sharedInstance].currentDivece) {
        NSDictionary *chatInfo = @{ @"speaker_id" : [OVSUserModel controlSpeakerId],
                             @"speaker_device_id" : [OVSUserModel controlSpeakerDeviceId]};
        if ([[OVSUserModel controlSpeakerId] isEqualToString:@""]||
            [[OVSUserModel controlSpeakerDeviceId] isEqualToString:@""]) {
            [self alertMessage:@"还没有设备,请先绑定设备"];
            return;
        }
        // 获取信息流列表
        [[OrionSDK shared] requestChatHistoryWithDeviceInfo:chatInfo
              conversationCount:10
             conversationOffset:0
                  startTimeline:0
                     completion:^(NSDictionary * _Nullable conversationInfo, NSError * _Nullable error) {
                         NSDictionary *chatData = [conversationInfo objectForKey:@"data"];
                         NSArray *chatItems = [chatData objectForKey:@"items"];
                         NSDictionary *chatInfo = [chatItems firstObject];
                         // 用户反馈接口，只是演示所以取了第一个记录
                         [[OrionSDK shared] feedbackWithHistoryID:[chatInfo objectForKey:@"historyId"]
                                                     feedbackType:OVSFeedbackTypeResponse
                                                    userFixedText:@"已反馈"
                                                       completion:^(NSDictionary * _Nullable feedbackInfo, NSError * _Nullable error) {
                                                           [super addContent:[@"获取信息流列表 " stringByAppendingString:(conversationInfo?conversationInfo.description:@"")]];
                                                           [super addContent:[@"反馈 " stringByAppendingString:(feedbackInfo?feedbackInfo.description:@"")]];
                                                       }];

                                                 }];
    } else {
        [self alertMessage:@"还没有设备,请先绑定设备"];
    }
}
            </span>
    </highlight-code>
      <h3 class="sedTitle">信息流UI 的使用</h3>

      <span>
<p class="ql-long-7802039">
	<span class="ql-author-7802039 ql-size-9">导入 OVSChat.framework</span>
</p>

<p class="ql-long-7802039">
	<strong class="ql-author-7802039 ql-size-9">信息流UI 可单独使用，不需要主动调用信息流API，但依然依赖信息流API</strong>
</p>

<p class="ql-long-7802039">
	<span class="ql-author-7802039 ql-size-9">以 viewControllerForURL 方式获取信息流控制器，信息流不支持 openURL 方式；</span>
</p>
</span>
<p class="ql-long-7802039">
	<strong class="ql-author-7802039 ql-size-9"></strong>
</p>

      <highlight-code lang="javascript">
         <span>
             + (UIViewController *)fetchChatViewController {
    // 路由URL 规则纯小写如 `ovs://chat`，ovs:// 前缀，后面加组件名称
    NSURL *routeUrl = [NSURL URLWithString:@"ovs://chat"];
    return [[OrionSDK shared] viewControllerForURL:routeUrl];
}
         </span>
      </highlight-code>
     <p></p>
  </div>
</template>

<script>
export default {
  name: ""
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
h1,
h2,
h3,
h4,
h5 {
  padding: 0;
  margin: 0px;
  font-weight: normal;
}

ul,
li {
  list-style: none;
}

.listmain {
  font-size: 14px;
  line-height: 26px;
  .firTitle {
    font-size: 20px;
    color: #1e4d79;
    margin-bottom: 30px;
  }
  .sedTitle {
    font-size: 16px;
    font-weight: bold;
    padding-bottom: 10px;
    border-bottom: 1px solid #f3f3f3;
    margin-bottom: 15px;
    margin-top: 50px;
    &.fir {
      margin-top: 0px;
    }
  }
  .thirdTitle {
    margin-top: 50px;
    font-weight: bold;
    line-height: 30px;
    font-size: 16px;
  }
  .codeTitle {
    font-weight: bold;
    line-height: 26px;
  }
  pre {
    margin-top: 20px;
  }
  img {
    margin: 30px 0;
    width: 100%;
  }
  table,
  table tr th,
  table tr td {
    border: 1px solid #000;
    text-align: center;
  }
  table {
    line-height: 30px;
    width: 100%;
    border-collapse: collapse;
  }
}

.el-submenu .el-menu-item {
  min-width: 190px;
  background: #f5f5f5;
}

.el-submenu {
  min-width: 190px;
  background: #f5f5f5;
}

img {
  margin-top: 30px;
  margin-bottom: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/tutor/SDK-ios/access/InfoFlow.vue